import { MapPin, Phone, Clock, Instagram, ArrowUpRight } from "lucide-react";

const HOURS = [
  { day: "Tuesday", time: "8:30 — 5:00" },
  { day: "Wednesday", time: "8:30 — 7:00" },
  { day: "Thursday", time: "8:30 — 7:00" },
  { day: "Friday", time: "8:30 — 7:00" },
  { day: "Saturday", time: "7:30 — 4:00" },
  { day: "Sunday", time: "Closed" },
  { day: "Monday", time: "8:30 — 5:30" },
];

export default function Visit() {
  return (
    <section
      id="visit"
      data-testid="visit-section"
      className="relative py-24 lg:py-36 bg-sand-50"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Left: info */}
          <div className="lg:col-span-5">
            <span className="overline">Come See Us</span>
            <h2 className="mt-6 font-serif font-light text-5xl lg:text-6xl text-ink-900 leading-[1.05] tracking-tight">
              Visit the<br />
              <span className="italic text-gold">salon.</span>
            </h2>
            <p className="mt-6 text-lg text-ink-500 leading-relaxed max-w-md">
              Drop in, call ahead, or book a free consultation. We&apos;ll
              pour the coffee.
            </p>

            {/* Contact blocks */}
            <div className="mt-10 space-y-px bg-black/10">
              <a
                href="https://www.google.com/maps/search/?api=1&query=1900+Dundas+St+W+Mississauga+ON+L5K+1P9"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-directions-link"
                className="flex items-start gap-5 bg-sand-50 p-6 hover:bg-sand-100 transition-colors group"
              >
                <MapPin className="w-5 h-5 text-gold mt-1" strokeWidth={1.5} />
                <div className="flex-1">
                  <p className="text-xs tracking-[0.2em] uppercase text-ink-500">Address</p>
                  <p className="mt-1 font-serif text-xl text-ink-900 leading-snug">
                    1900 Dundas Street West<br />
                    Mississauga, ON L5K 1P9
                  </p>
                </div>
                <ArrowUpRight className="w-5 h-5 text-ink-500 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </a>

              <a
                href="tel:+19058222690"
                data-testid="visit-call-link"
                className="flex items-start gap-5 bg-sand-50 p-6 hover:bg-sand-100 transition-colors group"
              >
                <Phone className="w-5 h-5 text-gold mt-1" strokeWidth={1.5} />
                <div className="flex-1">
                  <p className="text-xs tracking-[0.2em] uppercase text-ink-500">Telephone</p>
                  <p className="mt-1 font-serif text-xl text-ink-900">
                    (905) 822-2690
                  </p>
                </div>
                <ArrowUpRight className="w-5 h-5 text-ink-500 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </a>

              <a
                href="https://www.instagram.com/flavioshairdesign/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="visit-instagram-link"
                className="flex items-start gap-5 bg-sand-50 p-6 hover:bg-sand-100 transition-colors group"
              >
                <Instagram className="w-5 h-5 text-gold mt-1" strokeWidth={1.5} />
                <div className="flex-1">
                  <p className="text-xs tracking-[0.2em] uppercase text-ink-500">Follow</p>
                  <p className="mt-1 font-serif text-xl text-ink-900">
                    @flavioshairdesign
                  </p>
                </div>
                <ArrowUpRight className="w-5 h-5 text-ink-500 group-hover:text-gold group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </a>
            </div>
          </div>

          {/* Middle: Map */}
          <div className="lg:col-span-4">
            <div className="aspect-[4/5] lg:aspect-auto lg:h-full min-h-[400px] overflow-hidden border border-black/10">
              <iframe
                title="Flavio's House of Hair Design — Map"
                data-testid="visit-map"
                src="https://www.google.com/maps?q=1900+Dundas+St+W,+Mississauga,+ON+L5K+1P9&output=embed"
                className="w-full h-full grayscale contrast-110"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Right: Hours */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3 mb-6">
              <Clock className="w-5 h-5 text-gold" strokeWidth={1.5} />
              <span className="overline">Salon Hours</span>
            </div>
            <ul className="border-t border-black/10">
              {HOURS.map((h) => (
                <li
                  key={h.day}
                  data-testid={`hours-${h.day.toLowerCase()}`}
                  className="flex items-baseline justify-between py-4 border-b border-black/10 text-ink-900"
                >
                  <span className="font-serif text-lg">{h.day}</span>
                  <span className="text-sm text-ink-500 tabular-nums">{h.time}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs tracking-[0.2em] uppercase text-ink-500 leading-relaxed">
              24hr cancellation notice appreciated
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
